import __request__ from "routing/request";
export function systemStats() {
  return __request__("GET", "/system/stats", null, {}, {
    "Accept": ["application/json"]
  });
}
export function fsStats() {
  return __request__("GET", "/system/stats/fs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function jvmStats() {
  return __request__("GET", "/system/stats/jvm", null, {}, {
    "Accept": ["application/json"]
  });
}
export function networkStats() {
  return __request__("GET", "/system/stats/network", null, {}, {
    "Accept": ["application/json"]
  });
}
export function osStats() {
  return __request__("GET", "/system/stats/os", null, {}, {
    "Accept": ["application/json"]
  });
}
export function processStats() {
  return __request__("GET", "/system/stats/process", null, {}, {
    "Accept": ["application/json"]
  });
}
